export const votesSetting = {
  bingoVoiting: {
    '80bb6008-c287-4722-96a4-29b6b64a36d8': { isAllowed: true },
    '9d1c8f5a-6477-40cb-b44b-d1e4667ced5b': { isAllowed: true }, // ManchesterCity
    '7e4043e4-72f4-4891-b87d-31fbcca10284': { isAllowed: true }, //Metropolis
    'ed4a283c-2499-4295-b91c-0435922c9b22': { isAllowed: true }, //Sportapp
    '822034c4-8064-4a78-84c4-7a777ec272b3': { isAllowed: true,
      options: {
        moduleDescription: true,
      } }, //Patrick
    '80f53ef6-6373-11ea-bc55-0242ac130003': {
      isAllowed: true,
      options: {
        moduleDescription: true,
      }
    }
  },
  bestPlayerVoting: {
    '80bb6008-c287-4722-96a4-29b6b64a36d8': { isAllowed: true },
    '9d1c8f5a-6477-40cb-b44b-d1e4667ced5b': { isAllowed: true }, // ManchesterCity
    '7e4043e4-72f4-4891-b87d-31fbcca10284': { isAllowed: true }, //Metropolis
    'ed4a283c-2499-4295-b91c-0435922c9b22': { isAllowed: true }, //Sportapp
    '822034c4-8064-4a78-84c4-7a777ec272b3': { isAllowed: true }, //Patrick
    '80f53ef6-6373-11ea-bc55-0242ac130003': { isAllowed: true, title: 'Best song of a set (or album)' }
  },
  matchResultVoting: {
    '80bb6008-c287-4722-96a4-29b6b64a36d8': { isAllowed: true },
    '9d1c8f5a-6477-40cb-b44b-d1e4667ced5b': { isAllowed: true }, // ManchesterCity
    '7e4043e4-72f4-4891-b87d-31fbcca10284': { isAllowed: true }, //Metropolis
    'ed4a283c-2499-4295-b91c-0435922c9b22': { isAllowed: true }, //Sportapp
    '822034c4-8064-4a78-84c4-7a777ec272b3': { isAllowed: true }, //Patrick
    '80f53ef6-6373-11ea-bc55-0242ac130003': { isAllowed: false }
  }
};

export function getVotesConfig(clubId) {
  return {
    bingoConfig: votesSetting.bingoVoiting[clubId],
    bestPlayerVotingConfig: votesSetting.bestPlayerVoting[clubId],
    matchResultVotingConfig: votesSetting.matchResultVoting[clubId],
  }
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/votingConfig.js